<template>
  <div>
    test
  </div>
</template>

<script>

export default {
  name: 'Home',
  components: {
    
  },

  data () {
  	return {
  	
  	}
  },

  methods: {

  },

  mounted () {
  }
}
</script>
